import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import {BrowserRouter, Route, Routes} from 'react-router-dom';

import Home from './pages/Home'
import App from './pages/App';
import TermsOfUse from './pages/TermsOfUse';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <>
  //   <App />
  // </>
  
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/app" element={<App />} />
      <Route path="/terms-of-use" element={<TermsOfUse />} />
      {/* fallback route */}
      {/* <Route path="*" element={<NotFound />} /> */}
    </Routes>
  </BrowserRouter>
);
